// The checker
const isInView = el => {
  const scroll = window.scrollY || window.pageYOffset;
  const boundsTop = el.getBoundingClientRect().top + scroll;

  const viewport = {
    top: scroll,
    bottom: scroll + window.innerHeight - 100,
  };

  const bounds = {
    top: boundsTop,
    bottom: boundsTop + el.clientHeight,
  };

  return (
    (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
    (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
  );
};

window.addEventListener('load', () => {
  const donutCharts = document.querySelector('.js-open-rate');
  let chartsTriggered = false;

  const barCharts = document.querySelector('.js-bar-chart');
  const barsTriggered = false;

  const futureImage = document.querySelector('.js-the-future-image');
  const futureTriggered = false;

  const handler = () =>
    window.requestAnimationFrame(() => {
      if (donutCharts) {
        if (isInView(donutCharts)) {
          if (!chartsTriggered) {
            setTimeout(() => {
              const chartEvent = new Event('triggerCharts');
              window.dispatchEvent(chartEvent);
            }, 600);
            chartsTriggered = true;
          }
        }
      }

      if (barCharts) {
        if (isInView(barCharts)) {
          if (!barsTriggered) {
            barCharts.classList.add('active');
          }
        }
      }

      if (futureImage) {
        if (isInView(futureImage)) {
          if (!futureTriggered) {
            futureImage.classList.add('active');
          }
        }
      }
    });

  handler();
  window.addEventListener('scroll', handler);
});
